import getDecorators from "inversify-inject-decorators";
import container from "../../../ioc/inversify.config";
import TYPES from "../../../ioc/types";
import { DefaultEventService } from "../../../services/event-service";
import { GameStateService } from "../../../services/game-state-service";
import { MenuSceneParams } from "../../../shared/domain";
import {
    InventoryItemDTO,
    ItemEquipRequestDTO,
    ItemUsageRequestDTO,
    PartyDTO,
} from "../../../shared/dtos";
import { SceneId } from "../../../shared/enum";
import { PartyMenu } from "../../menu/party-menu";

const { lazyInject } = getDecorators(container);

export class MenuScene extends Phaser.Scene {
    private menu: PartyMenu;

    @lazyInject(TYPES.EventService)
    private eventService: DefaultEventService;

    @lazyInject(TYPES.GameStateService)
    private gameStateService: GameStateService;

    private itemToUse: InventoryItemDTO;

    private callingScene: Phaser.Scene;

    constructor() {
        super({ key: SceneId.MENU_SCENE });
        console.log("constructing menu scene");
    }

    preload() {}

    init(params: MenuSceneParams) {
        this.callingScene = params.scene;

        // listen for keyboard events
        this.input.keyboard.on("keydown", this.onKeyInput, this);
        this.events.on("sleep", () => {
            this.callingScene.scene.wake();
        });
        if (params && params.mode == "item_mode") {
            this.itemToUse = params.item;
        }
        this.scene.bringToTop();
    }

    public create(sceneId: string) {
        const party = PartyDTO.fromParty(this.gameStateService.gameState.party);
        const gold = this.gameStateService.gameState.gold || 0;

        /*        party.characters.forEach(character => {
            const actualStats = []
            character.stats.forEach(stat => {
                actualStats.push(new StatDTO(stat))
            })
            character.stats = actualStats
        });*/

        const screenWidth = this.physics.world.bounds.width;
        // probablement la hauteur du monde plutôt que de l'écran, ce qui entraîne ces calculs étranges
        // dans les positionnements des cards
        const screenHeight = this.physics.world.bounds.height;

        this.menu = new PartyMenu(0, 0, screenWidth, screenHeight, party, gold, this);
        this.menu.draw();

        // when the scene receives wake event
        this.sys.events.on("wake", () => this.scene.bringToTop());
    }

    public onKeyInput(event) {
        if (this.menu) {
            if (event.code === "ArrowUp") {
                this.menu.moveSelectionUp();
            } else if (event.code === "ArrowDown") {
                this.menu.moveSelectionDown();
            } else if (event.code === "Space") {
                console.log("this.itemToUse: ", this.itemToUse);
                if (this.itemToUse) {
                    if (this.itemToUse.item_definition.type === "consumable") {
                        console.log(
                            "trying to use ",
                            this.itemToUse,
                            " on ",
                            this.menu.selectedCharacter()
                        );
                        const request = new ItemUsageRequestDTO();
                        request.item_id = this.itemToUse.item_definition.item_definition_id;
                        request.user_id = this.menu.selectedCharacter().character_id;
                        request.targets_ids = [this.menu.selectedCharacter().character_id];
                        this.eventService.emit("use_item", request);
                    } else if (this.itemToUse.item_definition.type === "equipment") {
                        console.log(
                            "trying to equip ",
                            this.itemToUse,
                            " on ",
                            this.menu.selectedCharacter()
                        );
                        const request = new ItemEquipRequestDTO();
                        request.item_uuid = this.itemToUse.uuid;
                        request.target_id = this.menu.selectedCharacter().character_id;
                        this.eventService.emit("equip_item", request);
                    } else {
                        console.log("error: wrong type of object");
                    }
                } else {
                    console.log("no action implemented yet");
                }
            }
        }
    }
}
